import { render, staticRenderFns } from "./LomDocumnets.vue?vue&type=template&id=af11a1ce"
import script from "./LomDocumnets.vue?vue&type=script&lang=js"
export * from "./LomDocumnets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports